module.exports = __webpack_public_path__ + "caf4d193ed7d6f6ac153ae1b88ebcfa7.fbx";